// extracted by mini-css-extract-plugin
export default {"container":"Q045_P0uCMWPvHitOasm","title":"VEx2RGLtJUv_qJrH9oT1"};